/**
 * Query-key factory for the listings surface. Namespaced apart from
 * `dealQueryKeys` so a deals-list invalidation never clears listings
 * pages, and vice versa.
 */
export const listingQueryKeys = {
  all: ['listings'] as const,
  root: (orgId?: string) =>
    [...listingQueryKeys.all, 'root', ...(orgId ? [orgId] : [])] as const,
  /**
   * One level of the listings folder tree from
   * `/api/listings/tree`. `parentId` omitted means the org listings
   * root's children.
   */
  tree: (params: { parentId?: string; offset?: number } = {}, orgId?: string) =>
    [
      ...listingQueryKeys.all,
      'tree',
      ...(orgId ? [orgId] : []),
      params.parentId ?? 'root',
      ...(params.offset !== undefined ? [`offset=${params.offset}`] : []),
    ] as const,
  /** Synthetic Shared with Me folder for listings. */
  sharedWithMe: (orgId?: string) =>
    [
      ...listingQueryKeys.all,
      'shared-with-me',
      ...(orgId ? [orgId] : []),
    ] as const,
  /** Batch property-metadata hydration for rendered tree rows. */
  metaMap: (dealIds: string[], orgId?: string) =>
    [
      ...listingQueryKeys.all,
      'meta-map',
      ...(orgId ? [orgId] : []),
      [...new Set(dealIds)].sort().join(','),
    ] as const,
} as const;
